import { createSelector } from '@ngrx/store';
import { EventsState } from './events.state';

export const selectEventsState = (state: any) => state.events;

export const selectCalendarData = createSelector(
  selectEventsState,
  (state: EventsState) => state.calendar.data
);

export const selectCalendarLoading = createSelector(
  selectEventsState,
  (state: EventsState) => state.calendar.loading
);

export const selectCalendarError = createSelector(
  selectEventsState,
  (state: EventsState) => state.calendar.error
);

export const selectCalendarLastUpdated = createSelector(
  selectEventsState,
  (state: EventsState) => state.calendar.lastUpdated
);

export const selectCalendarLastQueryParams = createSelector(
  selectEventsState,
  (state: EventsState) => state.calendar.lastQueryParams
);

export const selectEventsFilters = createSelector(
  selectEventsState,
  (state: EventsState) => state.filters
);

export const selectPendingRequestId = createSelector(
  selectEventsState,
  (state: EventsState) => state.pendingRequestId
);

export const selectCalendarState = createSelector(
  selectEventsState,
  (state: EventsState) => state.calendar
);

